import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall, makeCallFile } from "utils/service";

export const downloadDocument = async (data: any) => {
  try {
    const callParams = await getCallParams("POST", data);
    const response: any = await makeCallFile(urls.DOWNLOAD_FILE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const doFetchAllTicketsMetrics = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(
      urls.FETCH_TICKETS_METRICS,
      callParams
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const doFetchAllTicketsByStatus = async (
  status: string,
  limit: any,
  page: any,
  searchText: string
) => {
  const url = `${urls.TICKETS_BY_STATUS}/${status}/limit/${limit}/page/${page}`;
  const body = {
    searchText,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const doFetchAllTicketsCountByStatus = async (
  status: string,
  searchText: string
) => {
  const url = `${urls.TICKETS_BY_STATUS}/${status}/count`;
  const body = {
    searchText,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
